// JOBE-0098.3: state 2 — "How to search this library" examples + Recent stack.

const EXAMPLES = [
  { token: 'owner:iris', gloss: 'Owned by a person' },
  { token: 'type:briefing', gloss: 'Filter by entity kind' },
  { token: 'vendor obs', gloss: 'Plain-text fallback' },
];

export function EmptyState({ recents, onPickRecent, onPickExample }) {
  return (
    <div className="omni-sections">
      <section className="omni-section omni-section-examples" aria-label="How to search this library">
        <h4 className="omni-section-title">How to search this library</h4>
        <ul className="omni-opt-list">
          {EXAMPLES.map((ex) => (
            <li key={ex.token}>
              <button
                type="button"
                className="omni-opt"
                onClick={() => onPickExample && onPickExample(ex.token)}
              >
                <code className="omni-opt-token">{ex.token}</code>
                <span className="omni-opt-gloss">{ex.gloss}</span>
              </button>
            </li>
          ))}
        </ul>
      </section>
      <section className="omni-section omni-section-recents" aria-label="Recent searches">
        <h4 className="omni-section-title">Recent</h4>
        {recents.length === 0 ? (
          <p className="omni-section-empty">no recent searches</p>
        ) : (
          <ul className="omni-opt-list">
            {recents.map((r, i) => (
              <li key={r.id}>
                <button
                  type="button"
                  className="omni-opt"
                  onClick={() => onPickRecent && onPickRecent(r)}
                >
                  <code className="omni-opt-token">{r.label}</code>
                  <span className="omni-opt-hint">
                    <kbd>⌘{i + 1}</kbd>
                  </span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
